import { graphql } from 'react-relay';
import copy from './authCopy';
import * as flows from './authFlowConstants';

// modal actions
export const LAUNCH_LOGIN_MODAL = 'LAUNCH_LOGIN_MODAL';
export function launchLoginModal(payload = {}) {
    if (payload.flow && !flows[payload.flow]) {
        console.warn(
            'invalid authentication flow name. make sure the flow is in authFlowConstants'
        );
    }
    return { type: LAUNCH_LOGIN_MODAL, payload };
}

export const LAUNCH_REGISTRATION_MODAL = 'LAUNCH_REGISTRATION_MODAL';
export function launchRegistrationModal(payload = {}) {
    if (payload.flow && !flows[payload.flow]) {
        console.warn(
            'invalid authentication flow name. make sure the flow is in authFlowConstants'
        );
    }
    return { type: LAUNCH_REGISTRATION_MODAL, payload };
}

export const LAUNCH_FORGOT_PASSWORD = 'LAUNCH_FORGOT_PASSWORD';
export function launchForgotPassword(payload) {
    return { type: LAUNCH_FORGOT_PASSWORD, payload };
}

export const LAUNCH_RESET_PASSWORD = 'LAUNCH_RESET_PASSWORD';
export function launchResetPasswordModal(payload) {
    return { type: LAUNCH_RESET_PASSWORD, payload };
}

export const LAUNCH_UPDATE_PASSWORD = 'LAUNCH_UPDATE_PASSWORD';
export function launchUpdatePasswordModal(payload) {
    return { type: LAUNCH_UPDATE_PASSWORD, payload };
}

export const LAUNCH_SOCIAL_ACCOUNT_LINKED = 'LAUNCH_SOCIAL_ACCOUNT_LINKED';
export function launchSocialAccountLinkedModal(payload) {
    return { type: LAUNCH_SOCIAL_ACCOUNT_LINKED, payload };
}

export const NEXT_STEP = 'NEXT_STEP';
export function nextStep(payload) {
    return { type: NEXT_STEP, payload };
}

export const CLOSE_MODAL = 'CLOSE_MODAL';
export function closeModal(payload) {
    return { type: CLOSE_MODAL, payload };
}

export const SHOULD_UPDATE_TOKEN = 'SHOULD_UPDATE_TOKEN';

// all error actions
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
export function handleRegistrationError(payload = {}) {
    const { message = '' } = payload;
    if (message.includes('SOCIAL_LOGIN_ONLY')) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.socialLoginOnly },
        };
    }
    if (message.includes(flows.SOCIAL_CASE_NO_EMAIL_RETURNED)) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.socialLoginNoEmailReturned },
        };
    }
    if (message.includes('USER_EXISTS')) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.conflictRegistration },
        };
    }
    return { type: AUTHENTICATION_ERROR, payload: { serverError: copy.errors.support } };
}

export const EMAIL_ONLY_CREATE_PASSWORD = 'EMAIL_ONLY_CREATE_PASSWORD';
export function handleLoginError(payload = {}) {
    const { message = '' } = payload;
    if (message.includes('SOCIAL_LOGIN_ONLY')) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.socialLoginOnly },
        };
    }
    if (message.includes(flows.SOCIAL_CASE_NO_EMAIL_RETURNED)) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.socialLoginNoEmailReturned },
        };
    }
    if (message.includes('INVALID_LOGIN')) {
        return { type: AUTHENTICATION_ERROR, payload: { serverError: copy.errors.invalidLogin } };
    }
    if (message.includes('NON_SUPPORTED_TRADE_LOGIN')) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.nonSupportedTradeLogin },
        };
    }
    if (message.includes(EMAIL_ONLY_CREATE_PASSWORD)) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.emailOnlyCreatePassword },
        };
    }
    return { type: AUTHENTICATION_ERROR, payload: { serverError: copy.errors.support } };
}
export function handleResetPasswordError(payload = {}) {
    const { message = '' } = payload;
    if (message.includes('invalid password token')) {
        return {
            type: AUTHENTICATION_ERROR,
            payload: { serverError: copy.errors.invalidResetToken },
        };
    } else if (message.includes('INVALID_LOGIN')) {
        return { type: AUTHENTICATION_ERROR, payload: { serverError: copy.errors.invalidLogin } };
    }
    return { type: AUTHENTICATION_ERROR, payload: { serverError: copy.errors.support } };
}
export const SET_DISABLE_EMAIL_ONLY_REGISTRATION = 'SET_DISABLE_EMAIL_ONLY_REGISTRATION';
export function setDisableEmailOnlyRegistration(isDisabled) {
    return {
        type: SET_DISABLE_EMAIL_ONLY_REGISTRATION,
        payload: { disableEmailOnlyRegistration: isDisabled },
    };
}
export const SET_AUTH_RESPONSE = 'SET_AUTH_RESPONSE';
export function setAuthResponse(res) {
    return {
        type: SET_AUTH_RESPONSE,
        payload: { authResponse: res },
    };
}
export const SAVE_AUTH_STATE = 'SAVE_AUTH_STATE';
export function saveAuthState(payload) {
    return {
        type: SAVE_AUTH_STATE,
        payload,
    };
}
export const UPDATE_AUTH = 'UPDATE_AUTH';
export function updateAuth(payload) {
    return {
        type: UPDATE_AUTH,
        payload,
    };
}

// fragment to be fetched for the user
export const fragment = graphql`
    fragment authActions on User {
        verifiedTradeStatus
    }
`;
